/* unplugin-vue-components disabled */import { render } from "./rightbar.vue?vue&type=template&id=851c899e&scoped=true"
import script from "./rightbar.vue?vue&type=script&lang=js"
export * from "./rightbar.vue?vue&type=script&lang=js"

import "./rightbar.vue?vue&type=style&index=0&id=851c899e&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-851c899e"],['__file',"src/pages/pulse/rightbar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "851c899e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('851c899e', __exports__)) {
    api.reload('851c899e', __exports__)
  }
  
  module.hot.accept("./rightbar.vue?vue&type=template&id=851c899e&scoped=true", () => {
    api.rerender('851c899e', render)
  })

}


export default __exports__